// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import RefreshCw from "@insite/mobius/Icons/RefreshCw";
import { orderInformationStyles } from "@steiner/Overrides/Widgets/OrderConfirmation/OrderConfirmationOrderInformation";
import { mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

orderInformationStyles.OrderInformationGridContainer = {
    gap: 24,
};

orderInformationStyles.orderDetailsGridItem = {
    width: 12,
};

orderInformationStyles.orderNumberGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

orderInformationStyles.orderNumberHeading = {
    variant: "h4",
    css: css`
        display: flex;
        gap: 5px;
        margin-bottom: 4px;
        aling-items: center;
    `,
};

orderInformationStyles.pageRefreshIcon = {
    src: RefreshCw,
    size: 18,
    color: "primary.main",
    css: css`
        cursor: pointer;
        margin-left: 10px;
    `,
};

orderInformationStyles.orderNumberText = {
    weight: "normal",
};

orderInformationStyles.orderDetailsGridContainer = {
    gap: 8,
    offsetCss: css`
        row-gap: 4px;
    `,
};

orderInformationStyles.orderInformationGridItems = {
    css: css`
        padding-bottom: 0;
        padding-top: 2px;
    `,
};

orderInformationStyles.headingAndTextStyles = {
    heading: {
        size: 14,
        weight: "bold",
        css: css`
            text-transform: none;
            white-space: nowrap;
            line-height: 18px;
            &:after {
                content: ":";
            }
        `,
    },
    text: {
        size: 14,
        css: css`
            line-height: 18px;
            text-transform: none;
        `,
    },
    wrapper: {
        css: css`
            flex-direction: row;
            gap: 5px;
        `,
    },
};

orderInformationStyles.orderDateGridItem = {
    width: 12,
};

orderInformationStyles.shippingMethodGridItem = {
    width: 12,
    css: css`
        &&&& {
            ${xScreen("lte", "xs")} {
                padding-top: 10px;
            }
        }
    `,
};

orderInformationStyles.statusGridItem = {
    width: 12,
};

orderInformationStyles.poNumberGridItem = {
    width: 12,
};

orderInformationStyles.salespersonGridItem = {
    width: 12,
};

orderInformationStyles.dueDateGridItem = {
    width: 12,
};

orderInformationStyles.notesTitle = {
    variant: "h6",
};

orderInformationStyles.notesDescription = {
    size: 14,
    weight: "normal",
    lineHeight: "22px",
};

orderInformationStyles.shippingInformationGridItem = {
    width: 12,
};

orderInformationStyles.billingInformationGridItem = {
    width: 12,
};

orderInformationStyles.leftSection = {
    width: [12, 6, 6, 6, 6],
};

orderInformationStyles.rightSection = {
    width: [12, 6, 6, 6, 6],
};
